<template>
  <template-card
    :name="name"
    icon="$paper_rectangle"
    @dragend:item="addItemDrop()"
    @click:item="addItem()" />
</template>
<script>
import paperBuilderToolMixin from '@/mixins/paperBuilderToolMixin'
import { v4 as uuid } from 'uuid'
import TemplateCard from './TemplateCard.vue'

export default {
  components: { TemplateCard },
  mixins: [
    paperBuilderToolMixin
  ],
  methods: {
    addItem () {
      const { left, top } = this.paperBuilderDrop || { left: '20px', top: '20px' }
      this.addPaperBuilderCanvas({
        id: this.paperBuilderId,
        data: {
          id: uuid(),
          type: 'triangle',
          tag: 'div',
          properties: {
            style: {
              position: 'absolute',
              left,
              top,
              width: '100px',
              height: '100px',
              borderTopWidth: '100px',
              borderLeftWidth: '100px',
              borderTopColor: 'transparent',
              borderColor: 'transparent',
              backgroundColor: '#c6c6c6'
            }
          },
          children: []
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
